import { PricingBottomCTA } from "./PricingBottomCTA";
import { PricingCards } from "./PricingCards";
import { PricingFAQ } from "./PricingFAQ";
import { PricingHero } from "./PricingHero";
import { MarketingPageLayout } from "../components/MarketingPageLayout";

const APP_URL = "https://app.scribenote.com/dashboard?companion";

export function PricingPage() {
  return (
    <MarketingPageLayout current="pricing">
      <PricingHero />
      <PricingCards ctaHref={APP_URL} />
      <PricingFAQ />
      <PricingBottomCTA getStartedHref={APP_URL} />
    </MarketingPageLayout>
  );
}
